export default __webpack_public_path__ + "dcc9973050e7f3cf27b78ccc91e900d5.webp";